// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","influencerSection":"socialPhotos_influencerSection__UFXIx"};